export default __webpack_public_path__ + "static/assets/aa52a97a8ebf84287c83f76fd541c659.png";